// Media of the homepage, copied from prototype/home/assets under content-hashed
// names (web/public/media), so they can be cached as immutable.

export type LoopMedia = { poster: string; webm: string; mp4: string };

export const JAR_LOOP: LoopMedia = {
  poster: "/media/head-poster.0e42950fb7.jpg",
  webm: "/media/head-idle.f468dc7716.webm",
  mp4: "/media/head-idle.6090610e23.mp4",
};

export const AVATAR_A_LOOP: LoopMedia = {
  poster: "/media/avatar-a.e45327dfa5.jpg",
  webm: "/media/avatar-a-idle.e7cad8381f.webm",
  mp4: "/media/avatar-a-idle.c48d0c5304.mp4",
};

export const AVATAR_B_LOOP: LoopMedia = {
  poster: "/media/avatar-b.4092e2f4d5.jpg",
  webm: "/media/avatar-b-idle.97d7331969.webm",
  mp4: "/media/avatar-b-idle.0d333b4a14.mp4",
};

export const AVATAR_C_LOOP: LoopMedia = {
  poster: "/media/avatar-c.5a4e82aadf.jpg",
  webm: "/media/avatar-c-idle.b3f5fc0f88.webm",
  mp4: "/media/avatar-c-idle.f8dcd982ec.mp4",
};

/** Hero looks in picker order: the jar first, then three example avatars. */
export const HERO_LOOKS = [
  { id: "jar", media: JAR_LOOP, thumb: { width: 1106, height: 1264 } },
  { id: "a", media: AVATAR_A_LOOP, thumb: { width: 720, height: 900 } },
  { id: "b", media: AVATAR_B_LOOP, thumb: { width: 720, height: 900 } },
  { id: "c", media: AVATAR_C_LOOP, thumb: { width: 720, height: 900 } },
] as const;

export type HeroLookId = (typeof HERO_LOOKS)[number]["id"];

/** The administrator who rises into the video-operator tablet. */
export const TABLET_LOOP = AVATAR_A_LOOP;

export type ClientLogo = { src: string; width: number; height: number };

/**
 * The client strip's logos: the banks' own files from their websites, shown
 * white on the page. Width and height are the viewBox, for the aspect ratio.
 * Globus Bank has an English wordmark; the others use one logo everywhere.
 */
export const CLIENT_LOGOS = {
  asvio: { uk: { src: "/media/client-asvio.df178005d2.svg", width: 1876, height: 336 } },
  crystalbank: { uk: { src: "/media/client-crystalbank.aa58e46c8a.svg", width: 960, height: 116 } },
  globus: {
    uk: { src: "/media/client-globus-uk.6325a60ae0.svg", width: 260, height: 47 },
    en: { src: "/media/client-globus-en.d2b8f94e41.svg", width: 552, height: 113 },
  },
} as const satisfies Record<string, { uk: ClientLogo; en?: ClientLogo }>;

export type ClientId = keyof typeof CLIENT_LOGOS;
